//
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type depositStatusProps = {
  currentStatus: string
}

const STATUS_CURRENT: any = {
  waitpay: "bg-[#2196f3] text-white",
  checking: "bg-amber-500 text-white",
  cancel: "bg-red-700 text-white",
  completed: "bg-emerald-700 text-white",
  refused: "bg-black text-white",
}

const ViewDepositStatus = ({ currentStatus }: depositStatusProps) => {
  const { t } = useTranslation();
  const [showStatus, setShowStatus] = useState(currentStatus)

  useEffect(() => {
    setShowStatus(currentStatus)
  }, [currentStatus])
  
  const styleclass = STATUS_CURRENT[showStatus] ? STATUS_CURRENT[showStatus] : 'bg-[#2196f3] text-white'
  return (
    <div className={`${styleclass} rounded-xl font-semibold text-center w-full text-xs md:text-sm opensans px-1`}>
      {t(`depositstatus.${showStatus}`)}
    </div>
  )
}

export default ViewDepositStatus